<template>

	<div id="contacto">
	  
	  <v-container style="position: relative;">


	  	<!-- iconos -->
	  	<v-icon id="contact-icon">mdi-email-outline</v-icon>
	  	<v-icon id="contact-icon2">mdi-phone</v-icon>
	  	
	      
    	<h1 class="text-center mb-5">Contacto</h1>

    	<v-row>
    		<v-col offset-md="3" md="6" offset-sm="2" sm="8">
    			<p id="contact-text">
    				<small>Envianos tus dudas y comentarios y responderemos a la brevedad posible.</small>
    			</p>
    		</v-col>
    	</v-row>


      <v-row>
        <v-col offset-md="2" md="8" offset-sm="1" sm="10">

        	<v-card id="contact-card">

        		<form @submit.prevent="sendMessage()">

	        		<v-row>
	        		  <v-col sm="6" cols="12">
	        		    <v-text-field label="Nombre" solo v-model="contact.name" required></v-text-field>
	        		  </v-col>
	        		  <v-col sm="6" cols="12">
	        		    <v-text-field label="Apellido" solo v-model="contact.last_name" required></v-text-field>
	        		  </v-col>
	        		</v-row>

	        		<v-row>
	        		  <v-col sm="6" cols="12">
	        		    <v-text-field label="Correo" solo v-model="contact.email" required type="email"></v-text-field>
	        		  </v-col>
	        		  <v-col sm="6" cols="12">
	        		    <v-text-field type="number" label="Teléfono" solo v-model="contact.phone" required></v-text-field>
	        		  </v-col>
	        		</v-row>

	        		<v-textarea
	        		  solo
	        		  label="Mensaje"
	        		  style="margin-top: 25px;"
	        		  v-model="contact.text"
	        		  required
	        		></v-textarea>

	        		<v-alert type="info" v-if="showAlertWait">
      		      Espera un momento...
      		    </v-alert>

	        		<div style="text-align: center;margin-top: 15px;">
	        			<v-btn type="submit" rounded x-large dark block :disabled="disabledBtn">CONTACTAR</v-btn>
	        		</div>

	        	</form>

        	</v-card>


        	<p id="contact-llamanos" v-if="phone_page != null">
        		<v-icon style="font-size: 2em;">mdi-phone</v-icon>
        		¡Llamanos al {{phoneFormat(phone_page)}}!
        	</p>
          
        </v-col>
      </v-row>

	  </v-container>

	</div>
</template>


<style>
	
	#contacto {
		padding-top: 25px;
		padding-bottom: 25px;
		background: #f4f4f4;
	}

	#contacto form {
		z-index: 1000 !important;
	}

	#contact-text {
		text-align: center;
		color: gray;
		font-weight: bold;
		text-transform: uppercase;
		z-index: 5 !important;
	}

	#contact-card {
		background: #151515;
		box-shadow: 4px 4px 3px 4px #d0d0d0;
		padding: 20px;
		padding-top: 40px;
		padding-bottom: 40px;
	}

	#contact-icon {
		font-size: 250px;
		position: absolute;
		color: #d0d0d0;
		left: 20;
		top: -20px;
		transform: rotate(-30deg);
		z-index: 1;
	}

	#contact-icon2 {
		font-size: 250px;
		position: absolute;
		color: #d0d0d0;
		right: 0;
		top: -15px;
		z-index: 1;
	}

	#contact-llamanos {
		text-align: center;
		margin-top: 40px;
		font-style: italic;
		color: gray;
		font-weight: bold;
		font-size: 1.5em;
	}

	@media(max-width: 959px) {

		#contact-icon, #contact-icon2 {
			display: none;
		}

	}

	@media(max-width: 425px) {

		#contact-llamanos {
			font-size: 1rem !important;
		}

	}


</style>


<script>
	
	import ContactService from '@/shared/services/ContactService'
	import SettingService from '@/shared/services/SettingService'

	export default
	{
		data() {
			return {
				contact: {
					name: null,
					last_name: null,
					email: null,
					phone: null,
					text: null
				},

				disabledBtn: false,
				showAlertWait: false,

				phone_page: null
			}
		},

		created() {
			this.getData()
		},

		methods: {

			async getData()
			{
				const resp = await SettingService.get()
				this.phone_page = resp.data.phone
			},

			async sendMessage()
			{
				this.disabledBtn = true
				this.showAlertWait = true

				const resp = await ContactService.sendMessage(this.contact)

				if(resp.data == 'OK')
				{
					SwalAlert('', 'Mensaje enviado', 'success')

					this.contact.name = null
					this.contact.last_name = null
					this.contact.email = null
					this.contact.phone = null
					this.contact.text = null
				}
				else
					SwalAlert('', 'Ha ocurrido un error, por favor intenta de nuevo', 'error')

				this.disabledBtn = false
				this.showAlertWait = false
			}

		}
	}

</script>